import * as math from 'mathjs';

class DiffCartesianC1 {
    run(T1, T2) {
        // Differenzvektor in der Position
        // delta_p = T2(1:3,4) - T1(1:3,4)
        let delta_p = math.subtract(
            math.subset(T2, math.index([0, 1, 2], 3)),
            math.subset(T1, math.index([0, 1, 2], 3))
        );

        // Berechnung Orientierungsfehler
        // A20 = T2(:,1:3) - Rotationsmatrix Ziel zu Referenz (K0)
        // If T2 is 4x4, take only first 3 rows; if 3x4, take all rows
        let T2_rows = T2.size()[0];
        let A20_rows = T2_rows >= 3 ? [0, 1, 2] : [...Array(T2_rows).keys()];
        let A20 = math.subset(T2, math.index(A20_rows, [0, 1, 2]));
        
        // A10 = T1(1:3,1:3) - Rotationsmatrix aktuell zu Referenz (K0)
        let T1_rows = T1.size()[0];
        let A10_rows = T1_rows >= 3 ? [0, 1, 2] : [...Array(T1_rows).keys()];
        let A10 = math.subset(T1, math.index(A10_rows, [0, 1, 2]));
        
        // A21 = A10'*A20 - Rotationsmatrix Ziel zu aktuell
        let A21 = math.multiply(math.transpose(A10), A20);

        // Normierung der Spaltenvektoren in A21 wegen der Gefahr numerischer Fehler
        // In MATLAB: l_vek=A21(:,1); l_vek=l_vek/norm(l_vek); A21=[l_vek m_vek n_vek]
        // Helper function to normalize a vector and extract as array
        const normalizeVector = (vec) => {
            vec = math.squeeze(vec);
            let vec_arr = vec.toArray ? vec.toArray() : (Array.isArray(vec) ? vec : [vec]);
            vec_arr = vec_arr.map(v => {
                let num = typeof v === 'number' ? v : (v && v.valueOf ? v.valueOf() : parseFloat(v));
                return isNaN(num) ? 0 : num;
            });
            let vec_norm = math.norm(vec_arr);
            if (vec_norm > 1e-10) {
                return vec_arr.map(v => v / vec_norm);
            }
            return vec_arr;
        };
        
        let l_vek_arr = normalizeVector(math.subset(A21, math.index([0, 1, 2], 0)));
        let m_vek_arr = normalizeVector(math.subset(A21, math.index([0, 1, 2], 1)));
        let n_vek_arr = normalizeVector(math.subset(A21, math.index([0, 1, 2], 2)));
        
        // In MATLAB: A21=[l_vek m_vek n_vek] - concatenates column vectors horizontally
        // Create matrix with columns as vectors, then transpose to get columns
        A21 = math.matrix([l_vek_arr, m_vek_arr, n_vek_arr]);
        A21 = math.transpose(A21); // Transpose to get columns (3x3 matrix)
        
        // Quaternionen
        // quat_1 = 0.5*sqrt(A21(1,1)+A21(2,2)+A21(3,3)+1)
        let a11 = math.subset(A21, math.index(0, 0));
        let a22 = math.subset(A21, math.index(1, 1));
        let a33 = math.subset(A21, math.index(2, 2));
        // Convert to numbers
        a11 = typeof a11 === 'number' ? a11 : (a11 && a11.valueOf ? a11.valueOf() : parseFloat(a11));
        a22 = typeof a22 === 'number' ? a22 : (a22 && a22.valueOf ? a22.valueOf() : parseFloat(a22));
        a33 = typeof a33 === 'number' ? a33 : (a33 && a33.valueOf ? a33.valueOf() : parseFloat(a33));
        let trace = (isNaN(a11) ? 0 : a11) + (isNaN(a22) ? 0 : a22) + (isNaN(a33) ? 0 : a33) + 1;
        if (trace < 0) trace = 0;
        let quat_1 = 0.5 * math.sqrt(trace);

        // phi = abs(2*acos(quat_1))
        let phi = math.abs(2 * math.acos(quat_1));

        return [math.squeeze(delta_p), phi];
    }
}

export default DiffCartesianC1;

